/* eslint-disable */
// q@ts-nocheck

import { ConstruktedAnnotationType } from "./types";

const annotations = [
    {
        attachments: [],
        author: { id: 3, name: "wugis1219" },
        color: "#fbc02d",
        comments: "0",
        date: "16 August, 2022",
        description: "",
        details:
            '{"polygonPositions" : [234218.88587330034,-5155155.674344605,3736197.0406531123,234221.10328563888,-5155154.752975518,3736197.894208936,234223.7199907345,-5155157.145832861,3736194.2011792962,234221.3112171145,-5155158.102824559,3736193.338976035,234218.88587330034,-5155155.674344605,3736197.0406531123], "gridCellSize": 1}',
        entity_id: "b69e43ac-efe3-40d3-9ac5-17a14c02c4ab",
        image: {
            id: -1,
            url: ""
        },
        image_plane_image: "",
        linewidth: "1",
        clamp_to_ground: "false",
        post_id: 5687,
        show_note_pin: "n",
        show_note_text: "n",
        show_note_leader: "n",
        title: "Volume measurement 1",
        type: "measurement_volume" as ConstruktedAnnotationType,
        view: false,
        asset: "",
        capture: ""
    },
    {
        attachments: [],
        author: { id: 3, name: "wugis1219" },
        color: "#fbc02d",
        comments: "0",
        date: "16 August, 2022",
        description: "",
        details: '{"x":-706119.0107155386,"y":-4973605.403534459,"z":3917610.5520582846}',
        entity_id: "b69e43ac-efe3-40d3-9ac5-17a14c02c4ab",
        image: {
            id: -1,
            url: ""
        },
        image_plane_image: "",
        linewidth: "1",
        clamp_to_ground: "false",
        post_id: 5687,
        show_note_pin: "n",
        show_note_text: "n",
        show_note_leader: "n",
        title: "Point measurement 1",
        type: "measurement_point" as ConstruktedAnnotationType,
        view: false,
        asset: "",
        capture: ""
    }
];

export default annotations;
